import React, { useEffect, useState } from "react";
import {
  DashboardOutlined,
  UsergroupAddOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  SettingOutlined,
  UserOutlined,
  FileOutlined,
  ApartmentOutlined,
  FileSearchOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import SidebarFooter from "./SidebarFooter";
import { useNavigate } from "react-router-dom";
import Logo from "./Logo";
import { useBasePath } from "../../hooks/useBasePath";
import SvgIcon from "../../const/SvgIcon";
import { ShowMenu } from "../../utils";
const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const { openKey, selectKey } = useBasePath();

  return (
    <Sider
      className="layout_sidebar"
      collapsible
      collapsed={collapsed}
      width={240}
      trigger={!collapsed ? <SidebarFooter /> : null}
    >
      <Logo collapsed={collapsed} />
      <div className="sidebar_menus">
        <Menu
          mode="inline"
          selectedKeys={selectKey}
          defaultOpenKeys={openKey}
          style={{ background: "#fecc4e" }}
          items={[
            {
              key: "dashboard",
              icon: <DashboardOutlined />,
              label: "Dashboard Management",
              onClick: () => {
                navigate("/");
              },
            }, {
              key: "city",
              icon: <FileSearchOutlined />,
              label: "City",
              style: { display: ShowMenu(["City"]) },
              onClick: () => {
                navigate("/city");
              },
            }, {
              key: "area",
              icon: <FileSearchOutlined />,
              label: "Area",
              style: { display: ShowMenu(["Area"]) },
              onClick: () => {
                navigate("/area");
              },
            },
            {
              key: "slider",
              icon: <FileSearchOutlined />,
              label: "Slider",
              style: { display: ShowMenu(["Slider"]) },
              onClick: () => {
                navigate("/slider");
              },
            },
            {
              key: "occasion",
              icon: <FileSearchOutlined />,
              label: "Occasion",
              style: { display: ShowMenu(["Occasion"]) },
              onClick: () => {
                navigate("/occasion");
              },
            },
            {
              key: "occasion-functions",
              icon: <FileSearchOutlined />,
              label: "Functions",
              style: { display: ShowMenu(["Functions"]) },
              onClick: () => {
                navigate("/occasion-functions");
              },
            },
            {
              key: "venue",
              icon: <FileSearchOutlined />,
              label: "Venue",
              style: { display: ShowMenu(["Venue"]) },
              onClick: () => {
                navigate("/venues");
              },
            },
            {
              key: "function-essentials",
              icon: <FileSearchOutlined />,
              label: "Essentials",
              style: { display: ShowMenu(["Essentials"]) },
              onClick: () => {
                navigate("/function-essentials");
              },
            },
            {
              key: "/essential-types",
              icon: <FileSearchOutlined />,
              label: "Essential Types",
              style: { display: ShowMenu(["Essential Types"]) },
              onClick: () => {
                navigate("/essential-types");
              },
            },
            {
              key: "/orders",
              icon: <FileSearchOutlined />,
              label: "Orders",
              style: { display: ShowMenu(["Orders"]) },
              onClick: () => {
                navigate("/orders");
              },
            },
            {
  key: "users",
  icon: <UsergroupAddOutlined />,
  label: "Users",
  style: { display: ShowMenu(["Users"]) },
  onClick: () => {
    navigate("/users");
  },
},
            {
  key: "gallery",
  icon: <FileSearchOutlined />,
  label: "Gallery",
  style: { display: ShowMenu(["Gallery"]) },
  onClick: () => {
    navigate("/gallery");
  },
},
{
  key: "youtube",
  icon: <FileSearchOutlined />,
  label: "YouTube",
  style: { display: ShowMenu(["YouTube"]) },
  onClick: () => {
    navigate("/youtube");
  },
},
          ]}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
